import { Component, ElementRef, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { HttpService } from "../../services/http.service";
import * as moment from "moment";
import { EditUploadsService } from "src/app/uploads/edit-uploads.service";
import { successMessage } from "../../shared/helpers/messages-popup";
import { filter, Subscription } from "rxjs";
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';
import { SelectItem } from 'src/app/shared/interfaces/select-item.interface';

@Component({
  selector: 'app-upload-bank',
  templateUrl: './upload-bank.component.html',
  styleUrls: ['./upload-bank.component.scss'],
})
export class UploadBankComponent implements  OnDestroy {
  bankMasterForm: FormGroup;
  isSubmitted = false;
  allCurrencyBankAccountData: any = [];
  allBankData: any = [];
  allAccData: any = [];
  allAccDataTemp: any = [];
  allCcyData: any = [];
  bankData: any = [];
  accData: any = [];
  selectedCurrencyInFilter: any;
  transactionTypes: any = [];
  ledgerOwnerData: any = [];
  statusData: any = [];
  modes: SelectItem[] = [];
  roles: SelectItem[] = [];
  reaccounts: any = [];
  multiple: boolean;
  show: boolean;
  private subscriptions = new Subscription();
  showUploadLoader = false;
  showValidateLoader = false;
  @ViewChild('fileUploader') fileUploader!: ElementRef;
  constructor(
    private http: HttpService,
    public editUploadsService: EditUploadsService,
    private apiClient: HttpClient,
  ) {}

  downloadTemplate() {
    const filename = 'banks_template.csv';
    const apiUrl = 'assets/resources/banks_template.csv';

    this.apiClient
      .get(apiUrl, { responseType: 'arraybuffer' })
      .subscribe((data: ArrayBuffer) => {
        const blob = new Blob([data], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
  }


  fileChangeValidate(element: any) {
    this.showValidateLoader = true;
    this.http.validateFile(element.target.files[0]).subscribe(
      (event: any) => {
        this.showValidateLoader = false;
        Swal.fire({
          icon: 'success',
          text: 'File successfully validated.',
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        });
        element.target.files = null;
        this.resetFileUploader();
      },
      (error) => {
        this.showValidateLoader = false;
        let errorMessage = error;
        if (Array.isArray(error)) {
          errorMessage = this.generateStringFromArrayWithLineBreak(
            error,
          );
        }
        Swal.fire({
          title: 'Error',
          icon: 'error',
          html: '<div class="poprow"> ' + errorMessage + '</div>',
          showConfirmButton: true,
          confirmButtonText: 'Close',
        }).then();
        this.resetFileUploader();
      },
    );
  }

  fileChange(element: any) {
    this.showUploadLoader = true;
    const file = element.target.files[0];
    if (!file) {
      this.showUploadLoader = false;
      return;
    }

    this.http.uploadFile(file).subscribe(
      (event: any) => {
        this.showUploadLoader = false;
        Swal.fire({
          icon: 'success',
          text: 'File successfully uploaded.',
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        });
        element.target.value = '';
      },
      (error) => {
        this.showUploadLoader = false;
        let errorMessage = error;
        if (Array.isArray(error)) {
          errorMessage = this.generateStringFromArrayWithLineBreak(error);
        }
        Swal.fire({
          title: 'Error',
          icon: 'error',
          html: `<div class="poprow">${errorMessage}</div>`,
          showConfirmButton: true,
          confirmButtonText: 'Close',
        });
        element.target.value = '';
      }
    );
  }


  generateStringFromArrayWithLineBreak(array: string[]): string {
    let result = '';
    array.forEach((item, index) => {
      result += item;
      if (index < array.length - 1) {
        result += '<hr></br>';
      }
    });
    return result;
  }

  resetFileUploader() {
    this.fileUploader.nativeElement.value = null;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
